import React, { useState } from "react";
import { Link } from "react-router-dom";
import { fmtPrice, waLink, skuFromHandle, productUrl } from "../lib/store";
import { InquiryDialog } from "./InquiryDialog";
import { WishlistButton } from "./WishlistButton";

export { InquiryDialog };

export default function ProductCard({ product }) {
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const onSale = product.compareAtPrice && product.compareAtPrice > product.price;

  return (
    <div className="group product-card" data-testid={`product-card-${product.handle}`}>
      <Link to={`/product/${product.handle}`} className="img-wrap block relative overflow-hidden aspect-square" data-testid={`product-link-${product.handle}`}>
        <img
          src={product.images[0]}
          alt={product.title}
          loading="lazy"
          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-[1.05]"
        />
        {onSale && (
          <span className="absolute top-3 left-3 bg-[#1a1713] text-[#f3ead2] text-[9px] tracking-[0.25em] uppercase px-2.5 py-1">Sale</span>
        )}
        {!product.available && (
          <span className="absolute bottom-3 left-3 bg-[#5c5240] text-white text-[9px] tracking-[0.25em] uppercase px-2.5 py-1">Sold Out</span>
        )}
        <div className="absolute top-2.5 right-2.5">
          <WishlistButton handle={product.handle} />
        </div>
      </Link>
      <div className="pt-4 pb-2 text-center">
        <Link to={`/product/${product.handle}`}>
          <h3 className="text-[15px] sm:text-sm tracking-wide text-[#2b261e] leading-snug line-clamp-2 min-h-[2.75rem] sm:min-h-[2.5rem] hover:text-[#a8842c] transition-colors duration-200 px-2">
            {product.title}
          </h3>
        </Link>
        <div className="flex items-baseline justify-center gap-2 mt-1.5">
          <span className="font-heading text-xl sm:text-lg text-[#1a1713]">{fmtPrice(product.price)}</span>
          {onSale && <span className="text-xs text-[#9c9482] line-through">{fmtPrice(product.compareAtPrice)}</span>}
        </div>
        {product.price > 0 ? (
          <button
            onClick={() => setInquiryOpen(true)}
            data-testid={`card-inquire-btn-${product.handle}`}
            className="mt-2 text-[11px] sm:text-[10px] tracking-[0.3em] uppercase text-[#7a7160] hover:text-[#a8842c] border-b border-[#d8cdb5] hover:border-[#a8842c] pb-0.5 transition-colors duration-300"
          >
            Inquire
          </button>
        ) : (
          <a
            href={waLink(`Hello Regal Jewels! Could you share the price of: ${product.title}\nSKU: ${skuFromHandle(product.handle)}\n${productUrl(product.handle)}`)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`card-ask-price-${product.handle}`}
            className="inline-block mt-2 text-[11px] sm:text-[10px] tracking-[0.3em] uppercase text-[#8a6a1f] hover:text-[#a8842c] border-b border-[#c9a24b] hover:border-[#a8842c] pb-0.5 transition-colors duration-300"
          >
            Ask Price on WhatsApp
          </a>
        )}
      </div>
      <InquiryDialog product={product} open={inquiryOpen} onOpenChange={setInquiryOpen} />
    </div>
  );
}
